import { jsx as _jsx } from "react/jsx-runtime";
import Icon from "../icon";
export default function Umbrella(props) {
    return (_jsx(Icon, { ...props, children: _jsx("path", { fillRule: "evenodd", d: "M3.894 4.134a12.05 12.05 0 0 1 20.101 7.771A1 1 0 0 1 23 13H13v6a2 2 0 0 0 4 0 1 1 0 1 1 2 0 4 4 0 1 1-8 0v-6H1a1 1 0 0 1-.995-1.095 12.05 12.05 0 0 1 3.89-7.771ZM21.84 11A10.05 10.05 0 0 0 2.16 11H21.84Z" }) }));
}
